import axios from 'axios';

import AuthService from '../../../service/AuthService/AuthService'

const auth = new AuthService();

const getDefaultState = () => {
  return {
    status: '',
    token: localStorage.getItem('token') || '',
    user: {},
    userName: '',
    resume: {}
  }
}

const state = getDefaultState()

const getters = {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  resume: state => state.resume,
};

const mutations = {
  auth_request(state) {
    state.status = 'loading'
  },
  auth_success(state, payload) {
    state.resume = {
      firstName: payload.firstName,
      lastName: payload.lastName,
      location: payload.location,
      phone: payload.phone,
      facebook: payload.facebook,
      twitter: payload.twitter,
      linkedin: payload.linkedin,
      about: payload.about,
      title: payload.title,
    }
  },
  auth_error(state) {
    state.status = 'error'
  },
  auth_update(state, payload) {
    state.resume = {
      firstName: payload.firstName ? payload.firstName : state.resume.firstName,
      lastName: payload.lastName ? payload.lastName : state.resume.lastName,
      location: payload.location ? payload.location : state.resume.location,
      phone: payload.phone ? payload.phone : state.resume.phone,
      facebook: payload.facebook ? payload.facebook : state.resume.facebook,
      twitter: payload.twitter ? payload.twitter : state.resume.twitter,
      linkedin: payload.linkedin ? payload.linkedin : state.resume.linkedin,
      about: payload.about ? payload.about : state.resume.about,
      title: payload.title ? payload.title : state.resume.title,
    }
  },
  logout(state) {
    Object.assign(state, getDefaultState())
  },
};

const actions = {
  login(context, credentials) {
    return new Promise((resolve, reject) => {
      auth.login(credentials)
        .then(response => {
          const token = response.data.access_token
          const idUser = response.data.user

          let myToken = `Bearer ${token}`;

          localStorage.setItem('token', token)
          localStorage.setItem('user', idUser)


          // axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          axios.defaults.headers.common['Authorization'] = myToken;

          context.dispatch('profile', {
            id: idUser
          })

          resolve(response)
        })
        .catch(err => {
          localStorage.removeItem('token')
          reject(err)
        })
    })
  },

  register({
    commit
  }, user) {
    return new Promise((resolve, reject) => {
      auth.register(user)
        .then(response => {
          const token = response.data.token

          let myToken = `Bearer ${token}`;
          const user = response.data.user
          localStorage.setItem('token', token)
          // axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          axios.defaults.headers.common['Authorization'] = myToken;
          commit('auth_success', token, user)
          resolve(response)
        })
        .catch(err => {
          commit('auth_error', err)
          localStorage.removeItem('token')
          reject(err)
        })
    })
  },

  profile(context, payload) {
    return new Promise((resolve, reject) => {
      auth.profile({
          id: payload.id
        })
        .then(response => {
          context.commit('auth_success', response.data)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  update(context, payload) {
    return new Promise((resolve, reject) => {
      payload.id = localStorage.getItem('user')

      console.log("Payload no auth.module: ", payload)
      auth.update(payload)
        .then(response => {
          console.log('Resposta do patch: ', response)
          context.commit('auth_update', payload)
          resolve(response)
        })
        .catch(erro => {
          reject(erro)
        })
    })
  },

  logout({
    commit
  }) {
    // eslint-disable-next-line no-unused-vars
    return new Promise((resolve, reject) => {
      commit('logout')
      localStorage.removeItem('token')
      delete axios.defaults.headers.common['Authorization']
      resolve()
    })
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};